import React, { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { useMatch } from 'react-router';
import TopBar from 'components/layout/topbar/topbar';
import RunsUsageBanner from 'components/layout/runs-usage-banner';
import NewLookBanner from 'components/new-look-banner/new-look-banner';
import NewLookModal from 'components/new-look-modal/new-look-modal';
import NavBar from 'components/layout/navbar/navbar';
import { legacyOnly, newDesignOnly } from 'constants/themes.constants';
import { css } from '@emotion/react';

export const MainLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const isProjectRoute = Boolean(useMatch('/p/:projectId/*'));
  return (
    <OuterContainer>
      <RunsUsageBanner />
      <TopBar page={isProjectRoute ? '/p/:projectId/*' : '/*'} />
      <BannerStack>
        <NewLookBanner />
      </BannerStack>
      <MainLayoutContainer>
        <NavBar />
        <ContentSlot>{children}</ContentSlot>
      </MainLayoutContainer>
      <NewLookModal />
    </OuterContainer>
  );
};

export const BannerStack = styled.div`
  display: flex;
  flex-direction: column;
  ${legacyOnly(css`
    gap: 2px;
  `)}
  ${newDesignOnly(css`
    gap: var(--spacing-xxxxs);
  `)}
`;

const OuterContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex: 1;
  max-height: 100%;
  overflow: hidden;
`;

const ContentSlot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryWhite};
  flex: 1;
  min-width: 0;
  max-height: 100%;
  overflow: hidden;
`;

export default MainLayout;
